/**
 * Project status sort order for consistent grouping across portal and internal views
 * Lower numbers appear first in the UI
 */
export const PROJECT_STATUS_SORT_ORDER: Record<string, number> = {
	started: 0,
	planned: 1,
	backlog: 2,
	paused: 3,
	completed: 4,
	triage: 5,
	unstarted: 6,
	canceled: 7,
	closed: 8,
}

/**
 * Get the sort order for a project status type
 * Returns Infinity for unknown statuses to sort them last
 */
export const getProjectStatusSortOrder = (
	status: string | null | undefined,
): number => {
	if (!status) return Infinity
	return PROJECT_STATUS_SORT_ORDER[status] ?? Infinity
}

/**
 * Collapse group keys that differ only by case (e.g. project "In Progress" +
 * issue "In progress") into one group, keeping the first-seen key's casing.
 * Accepts entries so callers can merge several sources in priority order.
 */
export function mergeGroupsCaseInsensitive<T>(
	entries: Array<readonly [string, T[]]>,
): Record<string, T[]> {
	const merged: Record<string, T[]> = {}
	const keyByLower = new Map<string, string>()
	for (const [key, value] of entries) {
		const canonical = keyByLower.get(key.toLowerCase())
		if (canonical) {
			merged[canonical] = [...(merged[canonical] ?? []), ...value]
		} else {
			keyByLower.set(key.toLowerCase(), key)
			merged[key] = value
		}
	}
	return merged
}
